/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from 'services/dto';
import http from '../httpInfrastructureService';
import {
  PagedTechnicalCategoryBookmarkRequest,
  PagedTechnicalCategoryRequest,
  TechnicalCategory,
  TechnicalCategoryBookmark,
  TechnicalCategoryBookmarkRequest,
  TechnicalCategoryRequest,
} from './dto/technicalCategory';

class TechnicalCategoryService {
  public async getAllCategories(
    pagedFilterAndSortedRequest: PagedTechnicalCategoryRequest
  ): Promise<PagedResultDto<TechnicalCategory>> {
    const result = await http.get('api/services/app/TechnicalCategory/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }
  public async getCategoriesByVinAndCategory(
    request: TechnicalCategoryRequest
  ): Promise<TechnicalCategory[]> {
    const result = await http.get(
      'api/services/app/TechnicalCategory/GetCategoriesByVinAndCategory',
      { params: request }
    );
    return result.data.result;
  }
  public async getSubCategoriesByCategoryId(request: EntityDto<string>): Promise<any[]> {
    const result = await http.get(
      'api/services/app/TechnicalCategory/GetSubCategoriesByCategoryId',
      { params: request }
    );
    return result.data.result;
  }

  public async getAllTechnicalCategoryBookmarks(
    pagedFilterAndSortedRequest: PagedTechnicalCategoryBookmarkRequest
  ): Promise<PagedResultDto<TechnicalCategoryBookmark>> {
    const result = await http.get('api/services/app/TechnicalCategoryBookmark/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }

  public async getTechnicalCategoryBookmark(
    request: TechnicalCategoryBookmarkRequest
  ): Promise<TechnicalCategoryBookmark> {
    const result = await http.get(
      'api/services/app/TechnicalCategoryBookmark/GetTechnicalCategoryBookmark',
      { params: request }
    );
    return result.data.result;
  }

  public async createTechnicalCategoryBookmark(request: TechnicalCategoryBookmarkRequest): Promise<TechnicalCategoryBookmark> {
    const result = await http.post('api/services/app/TechnicalCategoryBookmark/Create', request);
    return result.data.result;
  }

  public async removeTechnicalCategoryBookmark(entityDto: EntityDto<string>): Promise<any> {
    const result = await http.delete('api/services/app/TechnicalCategoryBookmark/Delete', {
      params: entityDto,
    });
    return result.data.result;
  }
}

export default new TechnicalCategoryService();
